import React, { useCallback, useMemo, useState } from "react";
import { ButtonFixedLayout } from "../../../../components/ButtonFixedLayout";
import { DataCard } from "../../../../components/DataCard";
import { InputFloatingLabel } from "../../../../components/InputFloatingLabel";

interface IProps {
	isLoading: boolean;
	onSubmit(cpf: string): Promise<void>;
}

const strings = {
	submitButton: "Continuar",
	title: "Digite seu número de celular",
	description: "Vamos enviar um código de acesso por SMS ",
	label: "DDD + número",
	placeholder: "DDD + número",
	messageError: "Tem algo errado com o número que você digitou. Dá uma conferida",
};

export const InsertPhoneStep: React.FC<IProps> = (props) => {
	const { onSubmit, isLoading } = props;
	const [ cellphone, setCellphone ] = useState<string>("");

	const cellphoneError = useMemo(()=> cellphone.length !== 0 && cellphone.length < 14, [cellphone]);
	const cellphoneSuccess = useMemo(()=> cellphone.length === 14, [cellphone]);

	const handleSubmit = useCallback(() => {
		onSubmit(cellphone);
	},[cellphone, onSubmit]);

	return (
		<ButtonFixedLayout
			primaryButton={{
				title: strings.submitButton,
				onClick: handleSubmit,
				variant: "solid",
				disabled: !cellphoneSuccess || isLoading,
			}}
			isFixed
		>
			<>
				<DataCard
					title={strings.title}
					description={strings.description}
				/>
				<InputFloatingLabel
					type='cellphone'
					value={cellphone}
					setValue={setCellphone}
					isError={cellphoneError}
					isSuccess={cellphoneSuccess}
					label={strings.label}
					placeholder={strings.placeholder}
					messageError={strings.messageError}
					hasIcon
				/>
			</>
		</ButtonFixedLayout>
	);
};
